import React, { useState, useEffect } from 'react';
import QuestionSummary from './QuestionSummary';
import M from 'materialize-css';
import Cookies from 'universal-cookie';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import Functions from '../../api/Functions';

function QuestionList(props) {
  const cookies = new Cookies();
  const { questions } = props;
  const [currentQType, setCurrentQType] = useState(cookies.get('qtype') || 'ALL');
  const [currentQuestions, setCurrentQuestions] = useState(questions);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const refModal2 = React.createRef();

  const onDelete = (questionId, question) => {
    const modal = M.Modal.getInstance(refModal2.current);
    modal.open();
    setSelectedQuestion(question);
  };

  const loadQuestionsByType = (qtype, questions) => {
    let filteredQuestions = questions.filter((question, index, array) => {
      return qtype === 'ALL' || question.type === qtype;
    });

    setCurrentQuestions(filteredQuestions);
  };

  const changeQType = (qtype) => {
    cookies.set('qtype', qtype);
    setCurrentQType(qtype);
  };

  const initLoading = () => {
    var elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  };

  useEffect(initLoading, []);

  useEffect(() => loadQuestionsByType(currentQType, questions), [currentQType, questions])

  const renderCountryFilter = () => {
    return (
      <div className="country-filter">
        <div className={'country-filter-item ' + (currentQType === 'ALL' ? 'qtype-filter-item-selected' : '')}>
          <a href="#all" onClick={(e) => changeQType('ALL')}>
            <div className="question-type">ALL</div>
          </a>
        </div>
        <div className={'country-filter-item ' + (currentQType === '1' ? 'qtype-filter-item-selected' : '')}>
          <a href="#ca" onClick={(e) => changeQType('1')}>
            <div className="question-type">T1</div>
          </a>
        </div>
        <div className={'country-filter-item ' + (currentQType === '2' ? 'qtype-filter-item-selected' : '')}>
          <a href="#us" onClick={(e) => changeQType('2')}>
            <div className="question-type">T2</div>
          </a>
        </div>
        <div className={'country-filter-item ' + (currentQType === '3' ? 'qtype-filter-item-selected' : '')}>
          <a href="#bo" onClick={(e) => changeQType('3')}>
            <div className="question-type">T3</div>
          </a>
        </div>
        <div className={'country-filter-item ' + (currentQType === '4' ? 'qtype-filter-item-selected' : '')}>
          <a href="#bo" onClick={(e) => changeQType('4')}>
            <div className="question-type">T4</div>
          </a>
        </div>
        <div className={'country-filter-item ' + (currentQType === '5' ? 'qtype-filter-item-selected' : '')}>
          <a href="#bo" onClick={(e) => changeQType('5')}>
            <div className="question-type">T5</div>
          </a>
        </div>
      </div>
    );
  };

  const deleteSelectedQuestion = () => {
    Functions
      .deleteTriviaQuestion(selectedQuestion)
      .then((response) => {
        console.log('Delete Question completed', response);
        return true;
      })
      .catch((error) => {
        console.warn('Delete Question Failed', error);
        return false;
      });
  };

  const renderDeleteDialog = () => {
    return (
      <div ref={refModal2} id="modalQuestion" className="modal">
        <div className="modal-content">
          <h5>Are you sure to delete "{selectedQuestion.question}" question?</h5>
          <p>This action will remove ALL data related to this question the moment it is removed</p>
        </div>
        <div className="modal-footer">
          <a href="#deleteQuestion" onClick={(e) => deleteSelectedQuestion()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className="company-list section">
      {renderCountryFilter()}
      <div className="title-section">Questions</div>
      {renderDeleteDialog()}
      {currentQuestions &&
        currentQuestions.map((question) => {
          return <QuestionSummary key={question.id} question={question} onDelete={onDelete} />;
        })}
    </div>
  );
}

export default compose(firestoreConnect())(QuestionList);
